<script lang="ts">
  import { _ } from "svelte-i18n";
  import InfoCards from "$lib/components/InfoCard/InfoCards/InfoCards.svelte";

  const cards = [
    {
      icon: "DELIVERY",
      title: $_("cards.shipping.headline"),
      description: $_("cards.shipping.text"),
      customIcon: true,
    },
    {
      icon: "RETURNS",
      title: $_("cards.returns.headline"),
      description: $_("cards.returns.text"),
      customIcon: true,
    },
    {
      icon: "SECUREPAYMENTS",
      title: $_("cards.paylater.headline"),
      description: $_("cards.paylater.text"),
      customIcon: true,
    },
    {
      icon: "CUSTOMERSUPPORT",
      title: $_("cards.contact.headline"),
      description: $_("cards.contact.text"),
      customIcon: true,
    },
  ];
</script>

<InfoCards {cards} />
